var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0957 7.35512H23.9049M1.0957 7.35512L12.5003 13.9524M1.0957 7.35512L12.5003 0.757812L23.9049 7.35512M1.0957 7.35512V20.6454M12.5003 13.9524L23.9049 7.35512M12.5003 13.9524V27.2427M12.5003 13.9524L1.0957 20.6454M12.5003 27.2427L23.9049 7.35512M12.5003 27.2427L1.0957 20.6454M12.5003 27.2427L23.9049 20.6454V7.35512",
    stroke: "#C1E2FF",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7988 13.6709L12.6494 13.584L2.24609 7.55762H23.4785L12.7988 26.1191V13.6709Z",
    stroke: "#C1E2FF",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorIcon);
export default __webpack_public_path__ + "main-static/media/cursor-icon.b46dab6a76f6777405599c7cc42f225c.svg";
export { ForwardRef as ReactComponent };